import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client';

const GENERATE_USER_ALIAS = gql`
  mutation GenerateUserAlias($userId: ID!, $userType: String!) {
    generateUserAlias(userId: $userId, userType: $userType) {
      success
      aliasId
      error
    }
  }
`;

interface GenerateUserAliasResult {
  generateUserAlias: {
    success: boolean;
    aliasId?: string;
    error?: string;
  };
}

interface GenerateUserAliasVariables {
  userId: string;
  userType: 'designer' | 'homeowner';
}

export const useGenerateUserAlias = () => {
  const [generateAlias, { loading, error }] = useMutation<
    GenerateUserAliasResult,
    GenerateUserAliasVariables
  >(GENERATE_USER_ALIAS);

  const generateUserAlias = async (userId: string, userType: 'designer' | 'homeowner') => {
    try {
      const result = await generateAlias({
        variables: { userId, userType }
      });
      
      return result.data?.generateUserAlias;
    } catch (err) {
      console.error('Error generating user alias:', err);
      return {
        success: false,
        error: 'Failed to generate alias'
      };
    }
  };

  return {
    generateUserAlias,
    loading,
    error
  };
};






















